import { GetterTree } from 'vuex'
import { ShippingState } from '@/modules/shipping/store'
import { RootState } from '@/store/types'
import _ from 'lodash'
import Rate from '@/modules/shipping/model/Rate'
import Region from '@/modules/shipping/model/Region'

const getters: GetterTree<ShippingState, RootState> = {
    tabulatedWeights: (state, getters): number[] => {
        const regions = getters.regions(state.currentRate)
        const weights = regions.map((r: Region) => r.weights.map(w => w.weight))

        return _.uniq(_.flatten(weights))
    },

    /**
     * Devuelve las regiones de una tarifa
     */
    regions: (state) => (rate: Rate) => state.regions.filter(r => r.rate.tempId === rate.tempId),
    regionsEditing: (state) => (rate: Rate) => state.regions.filter(r => r.rate.id === rate.id),
}

export default getters
